import { UserContext } from "@/context/User/UserContext";
import { getReporters } from "@/services/Reporter.service";
import { Reporter } from "@/types/reporter.types";
import { useQuery } from "@tanstack/react-query";
import { ColumnDef } from "@tanstack/react-table";
import { useContext } from "react";
import { NavLink } from "react-router-dom";
import CreateReporter from "../dialog/CreateReporter";
import ColumnHeader from "../table/ColumnHeader";
import LawFirmTable from "../table/LawFirmTable";
import { Button } from "../ui/button";
import { Skeleton } from "../ui/skeleton";

const Reporters = () => {
	const user = useContext(UserContext);

	const reporters = useQuery({
		queryKey: ["reporters"],
		queryFn: () => getReporters(user?.accessToken!),
		enabled: !!user?.accessToken,
		staleTime: 3000,
	});
	return (
		<div>
			<div className="flex justify-between items-center mb-4">
				<div>
					<h1 className="text-3xl font-bold">Reporters</h1>
				</div>
				<CreateReporter user={user} />
			</div>
			<div className="bg-white pb-4 border rounded-md shadow-sm">
				{reporters.isLoading ? (
					<div className="grid gap-4 pt-4">
						{Array.from({ length: 10 }).map((_, num) => (
							<Skeleton key={num} className="h-12 w-full" />
						))}
					</div>
				) : reporters.data ? (
					<LawFirmTable data={reporters.data} columns={Columns} />
				) : (
					<p>No data</p>
				)}
			</div>
		</div>
	);
};

export default Reporters;

const Columns: ColumnDef<Reporter>[] = [
	{
		accessorKey: "reporterid",
		header: ({ column }) => <ColumnHeader column={column} title="Reporter Id" />,
		cell: ({ row }) => (
			<div className="flex items-center">
				<NavLink to={`/reporter/${row.original.reporterid}`}>
					<Button variant="link" className="px-2 py-1 font-light">
						{row.getValue("reporterid")}
					</Button>
				</NavLink>
			</div>
		),
	},
	{
		accessorKey: "reportername",
		header: ({ column }) => <ColumnHeader column={column} title="Name" />,
	},
	{
		accessorKey: "designation",
		header: ({ column }) => <ColumnHeader column={column} title="Designation" />,
	},
	{
		accessorKey: "actions",
		cell: ({ row }) => (
			<div className="flex items-center">
				{/* <CreateReporter user={user} /> */}
			</div>
		),
	},
];
